import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment'
import { AgoraConfigService } from "src/AgoraConfigService";
@Injectable({ providedIn: 'root' })
export class LoginService {
  headers: any;
  agoraConfigObject: any;
  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;


    this.headers = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8')
      //.set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");

  }

  loginUser(userName: any, password: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.login}/login/validateUser`, { userName: userName, password: password }, { headers: this.headers, observe: 'response' });
  }
  getDecryptedDetails(reqJSON: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.login}/login/getDecryptUserDetails`, reqJSON, { headers: this.headers, observe: 'response' });
  }
  getVersionInfo() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.dashboard}` + "/versionInfo/agora", { headers: this.headers });
  }

  getRefreshTokenValue(reqJSON: any, httpOptions: any) {

    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.login}/login/` + 'refreshToken', reqJSON, { headers: httpOptions });
  }

  getTuleapProjectList() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.tuleap}` + "/getProject", { headers: this.headers, observe: 'response' });
  }
  getProjectList() {

    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.codelist}` + "getProjectList", { headers: this.headers, observe: 'response' });
  }
  getTuleapTrackersList(id: any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.tuleap}` + "/fetchTrackersForProject" + "/" + id, { headers: this.headers, observe: 'response' });
  }

  saveTuleapTask(reqJSON: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}createTuleapTask`, reqJSON, { headers: this.headers, observe: 'response' });
  }

  getTrackersDetails(id: any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.tuleap}` + "/fetchTrackersId" + "/" + id, { headers: this.headers, observe: 'response' });
  }

  getKeyPair() {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.login}/session/createKey`, { headers: this.headers, observe: 'response' });
  }

}
